import React from 'react'
import { CarouselContainer } from '../Carousel'
import CategoryThumbnail from './CategoryThumbnail'
import folderDocumentsIcon from '../../../assets/images/folder-documents.svg'

// A horizontally-scrollable row of category tiles.
const CategoryContainer = ({
  superElm,
  superElmIdx,
  onThumbClick,
  onEditName,
  onDeleteCategory,
  onEditDocumentName,
  onDeleteDocument,
  addToLeftRefs,
  addToRightRefs
}) => {
  const documentsPlaceholder = superElm && String(superElm.name).trim() === 'Documents'
    ? folderDocumentsIcon
    : null

  return (
    <CarouselContainer
      title={superElm.name}
      isSuper={true}
      superElmIdx={superElmIdx}
      addToLeftRefs={addToLeftRefs}
      addToRightRefs={addToRightRefs}
    >
      {superElm.subCategories?.map((elm, subCategoryIdx) => (
        <CategoryThumbnail
          key={`${superElmIdx}-${subCategoryIdx}`}
          elm={elm}
          subCategoryIdx={subCategoryIdx}
          onThumbClick={onThumbClick}
          onEditName={onEditName}
          onDeleteCategory={onDeleteCategory}
          onEditDocumentName={onEditDocumentName}
          onDeleteDocument={onDeleteDocument}
          placeholderOverride={documentsPlaceholder}
        />
      ))}
    </CarouselContainer>
  )
}

export default CategoryContainer
